// extracted by mini-css-extract-plugin
export default {"linksSection":"bK-z"};